export const removeBlur = function(image){
    if(image.elements.length === 1){
        const target = image.elements[0];
        target.classList.remove("blur");
    }
}

export const setImageSize = function () {
    const images = Array.from(document.querySelectorAll('.project-list__item'));
    images.forEach(
        image => {
            if (!image.classList.contains('project-list--type-full-width')) {
                const ratio = image.dataset.ratio;
                if(ratio){
                    const pos = image.getBoundingClientRect()
                    image.style.height = pos.width * 1 / ratio;
                }
            }

        }
    ) 
}

